module.exports = __webpack_public_path__ + "static/media/21ECLAC14.40441f6c.jpg";